export const dataLayer: any[] = [];

export const dataLayerPush = (data: any) => dataLayer.push(data);
